var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tariff',{attrs:{"type":"exam"}})
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/tariff/index.vue?vue&type=template&id=c87cc0f6&scoped=true
// module id = null
// module chunks = 